import { config } from 'zod';

/**
 * Turn off Zod's JIT path, for its side effect on the console.
 *
 * To choose between a compiled validator and an interpreted one, Zod probes
 * for `new Function`. The probe is wrapped in a try/catch, so under our CSP —
 * `script-src 'self' 'wasm-unsafe-eval'`, deliberately without
 * `'unsafe-eval'`, see nginx-csp.spec.ts — it fails over to the interpreted
 * path and validation works exactly as it should. What it does not do is stay
 * quiet: a `securitypolicyviolation` fires on the *attempt*, not on the
 * outcome, so every page load reported a blocked eval that nothing was
 * actually broken by, and Sentry captured each one.
 *
 * `jitless` skips the probe rather than swallowing it. Zod documents the flag
 * for this case and says so at the probe itself (`v4/core/util.js`,
 * `allowsEval`).
 *
 * Imported for the side effect, and before anything builds a schema: the flag
 * is read when an object schema is *constructed*, not when it parses, and the
 * probe's result is cached from its first use.
 */
config({ jitless: true });
